module.exports = __webpack_public_path__ + "img/ico_coinstore_daliychallenges@3x.e7b34e37.png";